import { SearchTab } from '@aipb/gulliver/catalog/model';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-result-tab-label',
  templateUrl: './result-tab-label.component.html',
  styleUrls: ['./result-tab-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, MatButtonModule]
})
export class ResultTabLabelComponent {
  @Input() searchTab: SearchTab;
  @Input() index: number;

  @Output() remove = new EventEmitter<SearchTab>();
}
